import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthFavoriteProviderLocation,
	GetHealthFavoriteProviderLocationModel,
	GetHealthFavoriteProviderLocationParams,
} from 'domain/usecases/private/booking-flow/health';

export class RemoteGetHealthFavoriteProviderLocation implements GetHealthFavoriteProviderLocation {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthFavoriteProviderLocationModel>,
	) {}

	async get({
		signal,
		...params
	}: GetHealthFavoriteProviderLocationParams): Promise<GetHealthFavoriteProviderLocationModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
